import { cssVars } from '../../utils';

export const drawerCssVars = cssVars({
  horizontalPadding: undefined,
  verticalFooterPadding: undefined,
});
